import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect, useState } from "react";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useCSRValue } from "../context";
import Button from "./button";
import * as ACTIONS from "../constants/actions";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #eee5e5",
    width: "calc(30vw)",
    borderRadius: "5px",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const ExpiredSessionModal = () => {
  const { csr, dispatch } = useCSRValue();
  const [isOpen, setIsOpen] = useState(!!csr.expired || false);
  const classes = useStyles();

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOk = () => {
    setIsOpen(false);
    dispatch({ type: ACTIONS.LOGOUT_SUCCESS_ACTION });
  };

  useEffect(() => {
    if (csr.expired) {
      setIsOpen(true);
    }
  }, [csr]);

  return (
    <div>
      <Modal
        className={classes.modal}
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        disableBackdropClick={true}>
        <div className={classes.paper}>
          <Grid container direction="row" alignItems="center" spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">
                Su sesión ha caducado. Vuelva a iniciar sesión
              </Typography>
            </Grid>

            <Grid container alignItems="center" justify="center" xs={12}>
              <Button type="button" onClick={handleOk}>
                Aceptar
              </Button>
            </Grid>
          </Grid>
        </div>
      </Modal>
    </div>
  );
};

export default ExpiredSessionModal;
